// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/common/measurement_units.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
export const protobufPackage = "squareup.connect.v2.common";
/**
 * --
 * @desc Unit of area used to measure a quantity.
 * --
 */
export var MeasurementUnit_Area;
(function (MeasurementUnit_Area) {
    MeasurementUnit_Area[MeasurementUnit_Area["INVALID_AREA"] = 0] = "INVALID_AREA";
    /**
     * IMPERIAL_ACRE - --
     * @desc The area is measured in acres.
     * --
     */
    MeasurementUnit_Area[MeasurementUnit_Area["IMPERIAL_ACRE"] = 4] = "IMPERIAL_ACRE";
    /**
     * IMPERIAL_SQUARE_INCH - --
     * @desc The area is measured in square inches.
     * --
     */
    MeasurementUnit_Area[MeasurementUnit_Area["IMPERIAL_SQUARE_INCH"] = 1] = "IMPERIAL_SQUARE_INCH";
    /**
     * IMPERIAL_SQUARE_FOOT - --
     * @desc The area is measured in square feet.
     * --
     */
    MeasurementUnit_Area[MeasurementUnit_Area["IMPERIAL_SQUARE_FOOT"] = 5] = "IMPERIAL_SQUARE_FOOT";
    /**
     * IMPERIAL_SQUARE_YARD - --
     * @desc The area is measured in square yards.
     * --
     */
    MeasurementUnit_Area[MeasurementUnit_Area["IMPERIAL_SQUARE_YARD"] = 6] = "IMPERIAL_SQUARE_YARD";
    /**
     * IMPERIAL_SQUARE_MILE - --
     * @desc The area is measured in square miles.
     * --
     */
    MeasurementUnit_Area[MeasurementUnit_Area["IMPERIAL_SQUARE_MILE"] = 7] = "IMPERIAL_SQUARE_MILE";
    /**
     * METRIC_SQUARE_CENTIMETER - --
     * @desc The area is measured in square centimeters.
     * --
     */
    MeasurementUnit_Area[MeasurementUnit_Area["METRIC_SQUARE_CENTIMETER"] = 2] = "METRIC_SQUARE_CENTIMETER";
    /**
     * METRIC_SQUARE_METER - --
     * @desc The area is measured in square meters.
     * --
     */
    MeasurementUnit_Area[MeasurementUnit_Area["METRIC_SQUARE_METER"] = 3] = "METRIC_SQUARE_METER";
    /**
     * METRIC_SQUARE_KILOMETER - --
     * @desc The area is measured in square kilometers.
     * --
     */
    MeasurementUnit_Area[MeasurementUnit_Area["METRIC_SQUARE_KILOMETER"] = 8] = "METRIC_SQUARE_KILOMETER";
    MeasurementUnit_Area[MeasurementUnit_Area["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MeasurementUnit_Area || (MeasurementUnit_Area = {}));
/**
 * --
 * @desc The unit of length used to measure a quantity.
 * --
 */
export var MeasurementUnit_Length;
(function (MeasurementUnit_Length) {
    MeasurementUnit_Length[MeasurementUnit_Length["INVALID_LENGTH"] = 0] = "INVALID_LENGTH";
    /**
     * IMPERIAL_INCH - --
     * @desc The length is measured in inches.
     * --
     */
    MeasurementUnit_Length[MeasurementUnit_Length["IMPERIAL_INCH"] = 1] = "IMPERIAL_INCH";
    /**
     * IMPERIAL_FOOT - --
     * @desc The length is measured in feet.
     * --
     */
    MeasurementUnit_Length[MeasurementUnit_Length["IMPERIAL_FOOT"] = 4] = "IMPERIAL_FOOT";
    /**
     * IMPERIAL_YARD - --
     * @desc The length is measured in yards.
     * --
     */
    MeasurementUnit_Length[MeasurementUnit_Length["IMPERIAL_YARD"] = 5] = "IMPERIAL_YARD";
    /**
     * IMPERIAL_MILE - --
     * @desc The length is measured in miles.
     * --
     */
    MeasurementUnit_Length[MeasurementUnit_Length["IMPERIAL_MILE"] = 6] = "IMPERIAL_MILE";
    /**
     * METRIC_MILLIMETER - --
     * @desc The length is measured in millimeters.
     * --
     */
    MeasurementUnit_Length[MeasurementUnit_Length["METRIC_MILLIMETER"] = 2] = "METRIC_MILLIMETER";
    /**
     * METRIC_CENTIMETER - --
     * @desc The length is measured in centimeters.
     * --
     */
    MeasurementUnit_Length[MeasurementUnit_Length["METRIC_CENTIMETER"] = 7] = "METRIC_CENTIMETER";
    /**
     * METRIC_METER - --
     * @desc The length is measured in meters.
     * --
     */
    MeasurementUnit_Length[MeasurementUnit_Length["METRIC_METER"] = 3] = "METRIC_METER";
    /**
     * METRIC_KILOMETER - --
     * @desc The length is measured in kilometers.
     * --
     */
    MeasurementUnit_Length[MeasurementUnit_Length["METRIC_KILOMETER"] = 8] = "METRIC_KILOMETER";
    MeasurementUnit_Length[MeasurementUnit_Length["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MeasurementUnit_Length || (MeasurementUnit_Length = {}));
/**
 * --
 * @desc The unit of volume used to measure a quantity.
 * --
 */
export var MeasurementUnit_Volume;
(function (MeasurementUnit_Volume) {
    MeasurementUnit_Volume[MeasurementUnit_Volume["INVALID_VOLUME"] = 0] = "INVALID_VOLUME";
    /**
     * GENERIC_FLUID_OUNCE - --
     * @desc The volume is measured in ounces.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["GENERIC_FLUID_OUNCE"] = 1] = "GENERIC_FLUID_OUNCE";
    /**
     * GENERIC_SHOT - --
     * @desc The volume is measured in shots.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["GENERIC_SHOT"] = 4] = "GENERIC_SHOT";
    /**
     * GENERIC_CUP - --
     * @desc The volume is measured in cups.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["GENERIC_CUP"] = 5] = "GENERIC_CUP";
    /**
     * GENERIC_PINT - --
     * @desc The volume is measured in pints.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["GENERIC_PINT"] = 6] = "GENERIC_PINT";
    /**
     * GENERIC_QUART - --
     * @desc The volume is measured in quarts.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["GENERIC_QUART"] = 7] = "GENERIC_QUART";
    /**
     * GENERIC_GALLON - --
     * @desc The volume is measured in gallons.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["GENERIC_GALLON"] = 8] = "GENERIC_GALLON";
    /**
     * IMPERIAL_CUBIC_INCH - --
     * @desc The volume is measured in cubic inches.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["IMPERIAL_CUBIC_INCH"] = 9] = "IMPERIAL_CUBIC_INCH";
    /**
     * IMPERIAL_CUBIC_FOOT - --
     * @desc The volume is measured in cubic feet.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["IMPERIAL_CUBIC_FOOT"] = 10] = "IMPERIAL_CUBIC_FOOT";
    /**
     * IMPERIAL_CUBIC_YARD - --
     * @desc The volume is measured in cubic yards.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["IMPERIAL_CUBIC_YARD"] = 11] = "IMPERIAL_CUBIC_YARD";
    /**
     * METRIC_MILLILITER - --
     * @desc The volume is measured in metric milliliters.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["METRIC_MILLILITER"] = 2] = "METRIC_MILLILITER";
    /**
     * METRIC_LITER - --
     * @desc The volume is measured in metric liters.
     * --
     */
    MeasurementUnit_Volume[MeasurementUnit_Volume["METRIC_LITER"] = 3] = "METRIC_LITER";
    MeasurementUnit_Volume[MeasurementUnit_Volume["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MeasurementUnit_Volume || (MeasurementUnit_Volume = {}));
/**
 * --
 * @desc Unit of weight used to measure a quantity.
 * --
 */
export var MeasurementUnit_Weight;
(function (MeasurementUnit_Weight) {
    MeasurementUnit_Weight[MeasurementUnit_Weight["INVALID_WEIGHT"] = 0] = "INVALID_WEIGHT";
    /**
     * IMPERIAL_WEIGHT_OUNCE - --
     * @desc The weight is measured in ounces.
     * --
     */
    MeasurementUnit_Weight[MeasurementUnit_Weight["IMPERIAL_WEIGHT_OUNCE"] = 1] = "IMPERIAL_WEIGHT_OUNCE";
    /**
     * IMPERIAL_POUND - --
     * @desc The weight is measured in pounds.
     * --
     */
    MeasurementUnit_Weight[MeasurementUnit_Weight["IMPERIAL_POUND"] = 5] = "IMPERIAL_POUND";
    /**
     * IMPERIAL_STONE - --
     * @desc The weight is measured in stones.
     * --
     */
    MeasurementUnit_Weight[MeasurementUnit_Weight["IMPERIAL_STONE"] = 6] = "IMPERIAL_STONE";
    /**
     * METRIC_MILLIGRAM - --
     * @desc The weight is measured in milligrams.
     * --
     */
    MeasurementUnit_Weight[MeasurementUnit_Weight["METRIC_MILLIGRAM"] = 2] = "METRIC_MILLIGRAM";
    /**
     * METRIC_GRAM - --
     * @desc The weight is measured in grams.
     * --
     */
    MeasurementUnit_Weight[MeasurementUnit_Weight["METRIC_GRAM"] = 3] = "METRIC_GRAM";
    /**
     * METRIC_KILOGRAM - --
     * @desc The weight is measured in kilograms.
     * --
     */
    MeasurementUnit_Weight[MeasurementUnit_Weight["METRIC_KILOGRAM"] = 4] = "METRIC_KILOGRAM";
    MeasurementUnit_Weight[MeasurementUnit_Weight["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MeasurementUnit_Weight || (MeasurementUnit_Weight = {}));
export var MeasurementUnit_Generic;
(function (MeasurementUnit_Generic) {
    MeasurementUnit_Generic[MeasurementUnit_Generic["INVALID_GENERIC_UNIT"] = 0] = "INVALID_GENERIC_UNIT";
    /**
     * UNIT - --
     * @desc The generic unit.
     * --
     */
    MeasurementUnit_Generic[MeasurementUnit_Generic["UNIT"] = 1] = "UNIT";
    MeasurementUnit_Generic[MeasurementUnit_Generic["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MeasurementUnit_Generic || (MeasurementUnit_Generic = {}));
/**
 * --
 * @desc Unit of time used to measure a quantity (a duration).
 * --
 */
export var MeasurementUnit_Time;
(function (MeasurementUnit_Time) {
    MeasurementUnit_Time[MeasurementUnit_Time["INVALID_TIME"] = 0] = "INVALID_TIME";
    /**
     * GENERIC_MILLISECOND - --
     * @desc The time is measured in milliseconds.
     * --
     */
    MeasurementUnit_Time[MeasurementUnit_Time["GENERIC_MILLISECOND"] = 1] = "GENERIC_MILLISECOND";
    /**
     * GENERIC_SECOND - --
     * @desc The time is measured in seconds.
     * --
     */
    MeasurementUnit_Time[MeasurementUnit_Time["GENERIC_SECOND"] = 2] = "GENERIC_SECOND";
    /**
     * GENERIC_MINUTE - --
     * @desc The time is measured in minutes.
     * --
     */
    MeasurementUnit_Time[MeasurementUnit_Time["GENERIC_MINUTE"] = 3] = "GENERIC_MINUTE";
    /**
     * GENERIC_HOUR - --
     * @desc The time is measured in hours.
     * --
     */
    MeasurementUnit_Time[MeasurementUnit_Time["GENERIC_HOUR"] = 4] = "GENERIC_HOUR";
    /**
     * GENERIC_DAY - --
     * @desc The time is measured in days.
     * --
     */
    MeasurementUnit_Time[MeasurementUnit_Time["GENERIC_DAY"] = 5] = "GENERIC_DAY";
    MeasurementUnit_Time[MeasurementUnit_Time["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MeasurementUnit_Time || (MeasurementUnit_Time = {}));
/**
 * --
 * @desc Describes the type of this unit and indicates which field contains the unit information. This is an ‘open’ enum.
 * --
 */
export var MeasurementUnit_UnitType;
(function (MeasurementUnit_UnitType) {
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    /**
     * TYPE_CUSTOM - --
     * @desc The unit details are contained in the custom_unit field.
     * --
     */
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["TYPE_CUSTOM"] = 1] = "TYPE_CUSTOM";
    /**
     * TYPE_AREA - --
     * @desc The unit details are contained in the area_unit field.
     * --
     */
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["TYPE_AREA"] = 2] = "TYPE_AREA";
    /**
     * TYPE_LENGTH - --
     * @desc The unit details are contained in the length_unit field.
     * --
     */
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["TYPE_LENGTH"] = 3] = "TYPE_LENGTH";
    /**
     * TYPE_VOLUME - --
     * @desc The unit details are contained in the volume_unit field.
     * --
     */
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["TYPE_VOLUME"] = 4] = "TYPE_VOLUME";
    /**
     * TYPE_WEIGHT - --
     * @desc The unit details are contained in the weight_unit field.
     * --
     */
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["TYPE_WEIGHT"] = 5] = "TYPE_WEIGHT";
    /**
     * TYPE_TIME - --
     * @desc The unit details are contained in the time_unit field.
     * --
     */
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["TYPE_TIME"] = 7] = "TYPE_TIME";
    /**
     * TYPE_GENERIC - --
     * @desc The unit details are contained in the generic_unit field.
     * --
     */
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["TYPE_GENERIC"] = 6] = "TYPE_GENERIC";
    MeasurementUnit_UnitType[MeasurementUnit_UnitType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MeasurementUnit_UnitType || (MeasurementUnit_UnitType = {}));
function createBaseMeasurementUnit() {
    return {
        $type: "squareup.connect.v2.common.MeasurementUnit",
        customUnit: undefined,
        areaUnit: undefined,
        lengthUnit: undefined,
        volumeUnit: undefined,
        weightUnit: undefined,
        genericUnit: undefined,
        timeUnit: undefined,
        type: undefined,
    };
}
export const MeasurementUnit = {
    $type: "squareup.connect.v2.common.MeasurementUnit",
    encode(message, writer = _m0.Writer.create()) {
        if (message.customUnit !== undefined) {
            MeasurementUnit_Custom.encode(message.customUnit, writer.uint32(10).fork()).ldelim();
        }
        if (message.areaUnit !== undefined) {
            writer.uint32(16).int32(message.areaUnit);
        }
        if (message.lengthUnit !== undefined) {
            writer.uint32(24).int32(message.lengthUnit);
        }
        if (message.volumeUnit !== undefined) {
            writer.uint32(32).int32(message.volumeUnit);
        }
        if (message.weightUnit !== undefined) {
            writer.uint32(40).int32(message.weightUnit);
        }
        if (message.genericUnit !== undefined) {
            writer.uint32(48).int32(message.genericUnit);
        }
        if (message.timeUnit !== undefined) {
            writer.uint32(56).int32(message.timeUnit);
        }
        if (message.type !== undefined) {
            writer.uint32(64).int32(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMeasurementUnit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.customUnit = MeasurementUnit_Custom.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.areaUnit = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.lengthUnit = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.volumeUnit = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.weightUnit = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.genericUnit = reader.int32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.timeUnit = reader.int32();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return MeasurementUnit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMeasurementUnit();
        message.customUnit = (object.customUnit !== undefined && object.customUnit !== null)
            ? MeasurementUnit_Custom.fromPartial(object.customUnit)
            : undefined;
        message.areaUnit = object.areaUnit ?? undefined;
        message.lengthUnit = object.lengthUnit ?? undefined;
        message.volumeUnit = object.volumeUnit ?? undefined;
        message.weightUnit = object.weightUnit ?? undefined;
        message.genericUnit = object.genericUnit ?? undefined;
        message.timeUnit = object.timeUnit ?? undefined;
        message.type = object.type ?? undefined;
        return message;
    },
};
function createBaseMeasurementUnit_Custom() {
    return { $type: "squareup.connect.v2.common.MeasurementUnit.Custom", name: undefined, abbreviation: undefined };
}
export const MeasurementUnit_Custom = {
    $type: "squareup.connect.v2.common.MeasurementUnit.Custom",
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.abbreviation !== undefined) {
            writer.uint32(18).string(message.abbreviation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMeasurementUnit_Custom();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.abbreviation = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return MeasurementUnit_Custom.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMeasurementUnit_Custom();
        message.name = object.name ?? undefined;
        message.abbreviation = object.abbreviation ?? undefined;
        return message;
    },
};
